import { render, staticRenderFns } from "./CateringFilters.vue?vue&type=template&id=13bd522d&scoped=true"
import script from "./CateringFilters.vue?vue&type=script&lang=ts"
export * from "./CateringFilters.vue?vue&type=script&lang=ts"
import style0 from "./CateringFilters.vue?vue&type=style&index=0&id=13bd522d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13bd522d",
  null
  
)

export default component.exports